import { YesNo } from '@uplift/types';
import { RadioControl, RadioControlProps } from '../../Inputs';
import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()(theme => ({
  radioMargin: {
    '& *[role=radiogroup]': {
      marginLeft: theme.spacing(1),
    }
  },
  inlineRadio: {
    '& > label': {
      width: '94px',
    },
  },
}));


export type YesNoRadioControlProps = {
  baseName: string;
  label: React.ReactNode;
  fullName?: string;
  inline?: true;
  color?: RadioControlProps['color'];
  disabled?: boolean;
};


const values = [ YesNo.Yes, YesNo.No ];


export const YesNoRadioControl: React.VFC<YesNoRadioControlProps> = ({ baseName, label, fullName, inline, color, disabled }) => {
  const { classes, cx } = useStyles();
  const name = fullName ?? `${baseName}YesNo`;

  return (
    <RadioControl
      disabled={disabled}
      name={name}
      label={label}
      values={values}
      row
      className={cx([ classes.radioMargin, {
        [classes.inlineRadio]: inline
      } ])}
      color={color || 'primary'}
      inline={inline}
      hideHelper={inline}
    />
  );
};

export type YesNoRadioControlInlineProps = {
  name: string;
  label: string;
};
